import firebase from 'firebase/app'
import router from '../../router'
import authAPI from '@api/auth-api'
import lineAPI from '@api/line-api'
import store from '@/store/index'
import qs from "qs";
import { Message, Loading } from 'element-ui';
import AuthStorage from '../storage/auth.storage';
import i18n from '@/helper/i18n'
import UserStorage from '../storage/user.storage';

const auth = {
    namespaced: true,
    state: {
        authDialog: false,
        isLoggedIn: UserStorage.userInfo ? true : false,
        reCaptchaApp: {
            window: null,
            widgetId: null,
        },
        otpTime: AuthStorage.timeOtp,
        loading: null,
        lineUID: null,
        lineInfo: null,
        refCodeOtp: null, 
        lineToken: UserStorage.userLineToken || null,
    },
    getters: {
        authDialog(state) {
            return state.authDialog
        },
        isLoggedIn(state) {
            return state.isLoggedIn
        },
        otpTime(state) {
            return state.otpTime;
        },
        lineUID(state) {
            return state.lineUID
        },
        lineInfo(state) {
            let info = state.lineInfo
            return info
        },
        refCodeOtp(state){
            return state.refCodeOtp
        },
        lineToken(state){
            return state.lineToken
        }
    },
    mutations: {
        OPEN_AUTH_DIALOG(state) {
            state.authDialog = true;
        },
        CLOSE_AUTH_DIALOG(state) {
            state.authDialog = false;
        },
        SET_USER_LOGIN(state, data) {
            state.isLoggedIn = data
        },
        SET_LINE_UID(state, data) {
            state.lineUID = data
        },
        SET_LINE_INFO(state, data) {
            state.lineInfo = data
        },
        SET_OTP_TIME(state, data) {
            state.otpTime = data;
            AuthStorage.timeOtp = data;
        },
        CLEAR_OTP_TIME(state) {
            state.otpTime = null;
            AuthStorage.clear();
        },
        SET_REF_CODE_OTP(state, data){
            state.refCodeOtp = data;
        },
        SET_LINE_TOKEN(state, data){
            state.lineToken = data
        },
        SET_LINE_TOKEN_LOCAL(state, data){
            UserStorage.userLineToken = data;
        },
        clearUserLineToken(state) {
            state.userLineToken = null;
            localStorage.removeItem('line-token-regis');
        }
    },
    actions: {
        registerUser: async ({ }, payload) => {
            return await authAPI.registerUserHandler(payload)
            .then((result) => {
                if(result.data.point > 0 ){
                    localStorage.setItem('register-points', JSON.stringify({
                        point: result.data.point,
                        restaurantUuid: result.data.restaurantUuid
                    }));
                }
            })
        },
        saveLineInfo: ({ commit }, payload) => {
            commit("SET_LINE_INFO", payload);
        },
        checkPhoneNumber: async ({ }, payload) => {
            // ยิงเช็คว่ามีเบอร์ยังใน db
            return await authAPI.checkPhoneHandler(payload)
                .then((result) => {
                    return result.data.data.status; // true มี false ไม่มี
                }).catch(() => {
                    return false
                })
        },
        validateLine: async ({ commit }, payload) => {
            return authAPI.validateLineHandler(payload)
              .then(async (response) =>  {
                if (response.status === 200 && !response.data.isNew) {
                    let tokenText = `${response.data.tokenType} ${response.data.accessToken}`
                    await store.commit("user/SET_USER_TOKEN", tokenText);
                    await store.dispatch("user/fetchUserInfo");
                    return { token: response.data.accessToken };
                } else if (response.status === 201 && response.data.isNew) {
                    await commit("SET_LINE_TOKEN", response.data.lineAccessToken);
                    return true
                } else {
                  return false;
                }
              })
              .catch((error) => {
                throw error;
              });
        },
        registerLine: async ({ commit }, payload) => {
            return await authAPI
                .registerLineHandler(payload)
                .then(async response => {
                    if (response.status === 200) {
                        const lineUserId = response.data.lineUserId
                        const userInfo = store.getters['user/userInfo']
                        userInfo.lineUid = lineUserId
                        await store.commit('user/SET_USER_INFO', userInfo)
                        await commit("SET_LINE_TOKEN", response.data.token);
                        await commit("SET_LINE_TOKEN_LOCAL", response.data.token);
                        await store.dispatch("user/fetchUserInfo");
                        return response.status
                    }
                    throw 500
                })
                .catch(error => {
                    throw error.response.status
                })
        },
        closeLine: async ({ }, payload) => {
            await authAPI.closeLineHandler(payload)
              .then(async (response) => {
                if (response.status !== 200) {
                  Message.error(i18n.t('store.auth.error-occurred')+" !");
                  router.push({ name: "ProfileSetting" });
                  return
                }
                const userInfo = store.getters["user/userInfo"]
                userInfo.lineUid = ''
                await store.commit("user/SET_USER_INFO", userInfo);
              })
              .catch((error) => {
                Message.error(i18n.t('store.auth.error-occurred')+" !");
                router.push({ name: "ProfileSetting" });
                throw error;
              });
        },
        redirectLine: async ({},payload) => {
            const data = qs.stringify({
              code_challenge: payload.code_challenge,
              code_challenge_method: "S256",
              response_type: "code",
              client_id: payload.channelID,
              redirect_uri: payload.REDIRECT_URI,
              scope: "email profile openid",
              bot_prompt: "aggressive",
              state: payload.codeVerifier,
            });

            window.open(
              "https://access.line.me/oauth2/v2.1/authorize/?" + data,
              "_self"
            );
        },
        async getLineToken({ state, dispatch, commit }, payload) {
            await lineAPI.getLineTokenHandler(payload)
              .then(async (response) => {
                if (response.status == 200 && response.data.access_token ) {
                    await store.commit("user/SET_LINE_FRIEND_TOKEN", response.data.access_token);
                    await store.dispatch("user/fetchUserInfo");
                    return
                }
              })
              .catch((error) => {
                throw error;
              });
        },
        async handleErrorSignInWithPhone({ }, errorCode) {
            const errorMsg = {
                400: i18n.t('store.auth.invalid-phone'),
                401: i18n.t('store.auth.invalid-otp'),
                409: i18n.t('store.auth.otp-too-often'),
            }[errorCode];

            if (!errorMsg) {
                Message.warning( i18n.t('store.auth.try-later') );
                setTimeout(() => { window.location.reload() }, 2000);
            } else {
                throw {
                    error: errorCode,
                    message: errorMsg,
                };
            }
        },
        async verifyPhoneNumber({ state, dispatch, commit }, payload) {
            const dataSent = {
                phoneNumber: payload.PhoneNumberRef2,
                phoneCountryCode: payload.countryCode,
                recaptchaToken: payload.recaptchaToken
            };
            return await authAPI.sentVerifyPhoneCRMHandler(dataSent)
                .then((res) => {
                    if(res.status == 201){
                        commit('SET_REF_CODE_OTP', res.data.refCode)
                        router.push({
                            path: `/otp`,
                            query: {
                                PhoneNumberRef1: payload.PhoneNumberRef1,
                                PhoneNumberRef2: payload.PhoneNumberRef2,
                                countryCode: payload.countryCode,
                                refCode: res.data.refCode
                            }
                        });
                    }
                })
                .catch(async (error) => {
                    const errorCode = error && error.response && error.response.status ? error.response.status:500
                    return await dispatch('handleErrorSignInWithPhone', errorCode)
                })
        },
        verifyCodeOTP: async ({commit}, payload) => {
            await authAPI.verifyCodeCRMHandler(payload)
            .then(async( res )=>{
                const tokenText = `${res.data.tokenType} ${res.data.accessToken}`
                await store.commit('user/SET_USER_TOKEN', tokenText )
                if(UserStorage.userLineToken)
                    commit('clearUserLineToken');
                return true
            })
            .catch((error)=>{
                throw error;
            })
        },
        setUserLogin: async ({ commit }, payload) => {
            await store.dispatch('user/fetchUserInfo');
            commit('SET_USER_LOGIN', true);
        },
        async checkLogin({ dispatch }) {
            return await authAPI.checkLoginHandler().catch( async error => {
                if (error.response.status === 401) {
                    Message.error({
                        duration: 2000,
                        message: 'session expired, please login !',
                    })
                    await dispatch('doLogout')
                    router.push({ name: "Login" });
                }else{
                    router.go(0)
                }
            })
        },
        doLogout: async ({ commit }) => {
            commit('SET_USER_LOGIN', false);
            store.dispatch("user/clearUserData");
        },
        login: async ({ state, dispatch, commit }, payload) => {
            const branchInfo = store.getters["branch/branchInfo"]
            await store.dispatch('user/fetchUserInfo');
            commit('SET_USER_LOGIN', true);
            router.push({
                name: "Home",
                params: {
                    restaurant_aliase: store.getters["restaurant/restaurantUUID"],
                    branch_aliase: store.getters["branch/branchUUID"],
                },
            })
        }
    }
}

export default auth
